import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router";
import { NewButton } from "../../components/Buttons/PrimaryButton/styles";
import { Page } from "../../components/Page";
import { request } from "../../services/request";
import sweetAlert from "../../utils/sweetAlert";
import { GuestTexArea } from "./styles";

export const Pauses: React.FC = () => {
  const [tabbings, setTabbings] = useState<string>("");
  const { clientId } = useParams<{ clientId: string }>();

  const getTabbings = async () => {
    const response = await request({
      method: "GET",
      path: `enterprises/attendant-pauses`,
      showSuccessMessage: false,
    });

    if (!response.error) {
      setTabbings(response.join("\n"));
    }
  };

  const formatNames = (value: string) => {
    let valueInArray: Array<string> = value.split("\n");
    valueInArray = valueInArray.filter((v) => v !== "");

    let values = valueInArray.map((v) => {
      return { value: v.split(",")[0], type: v.split(",")[1] };
    });

    let withoutDuplicates: Array<string> = [];

    values.forEach((v, i) => {
      if (!v) return;
      let alreadyExist = false;
      values.forEach((vAe, index) => {
        if (vAe.value === v.value && i !== index) {
          alreadyExist = true;
        }

        if (vAe.value === v.value && i === index) {
          alreadyExist = false;
        }
      });

      if (!alreadyExist) {
        withoutDuplicates.push(`${v.value}`);
      }
    });

    return { values: withoutDuplicates, success: true };
  };

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let value = e.target.value;
    setTabbings(value);

    let values = formatNames(value);

    if (!values.success) {
      sweetAlert.error(
        `Nomes duplicados, remova-os: \n ${values.values.join("\n")}`
      );
    }
  };

  const handleSave = async () => {
    let values = formatNames(tabbings);

    if (!values.success) {
      sweetAlert.error(
        `Pausas duplicadss, remova-os: \n ${values.values.join("\n")}`
      );
      return;
    }

    await request({
      method: "PUT",
      path: `enterprises/attendant-pauses`,
      data: { pauses: values.values },
    });
  };

  useEffect(() => {
    getTabbings();
  }, []); //eslint-disable-line

  return (
    <Page header={`Pausas`}>
      <Fragment></Fragment>
      <Fragment>
        <p>Pausas dos atendentes separadas por enter, exemplo: </p>
        <br></br>
        <p>
          Almoço <br></br>
          Pausa 1 <br></br>
        </p>

        <GuestTexArea onChange={handleChangeTextArea} value={tabbings} />
      </Fragment>
      <NewButton onClick={handleSave}>salvar</NewButton>
    </Page>
  );
};
